import {
  ACTIVITY_BUILDER_A4_SHORT_SIDE,
  ACTIVITY_BUILDER_ACTIVITY_HEIGHT,
  ACTIVITY_BUILDER_FOOTER_HEIGHT,
  ACTIVITY_BUILDER_HEADER_HEIGHT,
} from '../activity-builder.constants';

export function getContentHeight({
  showHeaders,
  includeDifferentiation,
}: {
  showHeaders: boolean;
  includeDifferentiation: boolean;
}) {
  let pageHeight = ACTIVITY_BUILDER_A4_SHORT_SIDE;
  let contentHeight =
    pageHeight -
    (ACTIVITY_BUILDER_HEADER_HEIGHT + ACTIVITY_BUILDER_FOOTER_HEIGHT);

  if (!showHeaders) {
    pageHeight -=
      ACTIVITY_BUILDER_HEADER_HEIGHT + ACTIVITY_BUILDER_FOOTER_HEIGHT;
  }

  if (!includeDifferentiation) {
    contentHeight -= ACTIVITY_BUILDER_ACTIVITY_HEIGHT;
    pageHeight -= ACTIVITY_BUILDER_ACTIVITY_HEIGHT;
  }

  return {
    pageHeight,
    contentHeight,
  };
}
